import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DatePicker } from "@react-shamsi/datepicker";
import moment from 'moment-jalaali';
import { getCargoById, updateCargo } from '../../actions/cargo/cargo';
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { CircularProgress } from "@mui/material";
import ModalSelectMachine from "../../components/Modal/Machine/ModalMachineSelect";
import ModalDriverSingleWithData from "../../components/Modal/Driver/DriverSingleWithData";
import ModalSelectEquipment from "../../components/Modal/Equipment/ModalEquipmentSelect";
import ModalOperatorSingleWithData from "../../components/Modal/Operator/OperatorSingleWithData";
import ModalSelectProject from "../../components/Modal/Project/ProjectSelectModal";
import ModalSelectLocation from "../../components/Modal/Locations/LocationSelectModal";
import ModalSelectPeymankar from "../../components/Modal/Peymankar/PeymankarSelectModal";
import ModalSelectOrigin from "../../components/Modal/Origin/OriginSelectModal";
import ModalSelectDestination from "../../components/Modal/Destination/DestinationSelectModal";
import ModalSelectShift from "../../components/Modal/Shift/ShiftSelectModal";
import ModalSelectJens from "../../components/Modal/Jens/JensSelectModal";
import ModalSelectJensCode from "../../components/Modal/JensCodes/JensCodeSelectModal";
import ModalSelectWeight from "../../components/Modal/Weight/WeightSelectModal";

export default function EditCargoPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pending, setPending] = useState(false);

  const [formData, setFormData] = useState({
    rent: "",
    totalCost: "",
    operation: 1,
    description: "",
  });

  const [selectedDate, setSelectedDate] = useState();
  const [fields, setFields] = useState([]);

  const [data, setData] = useState({id:"",title:"",drivers:[]});
  const [dataDriver, setDataDriver] = useState({id:"",title:""});
  const [dataEquipment, setDataEquipment] = useState({id:"",title:"",operators:[]});
  const [dataOperator, setDataOperator] = useState({id:"",title:""});
  const [dataProject, setDataProject] = useState({id:"",title:""});
  const [dataLocations, setDataLocations] = useState({id:"",title:""});
  const [dataPeymankar, setDataPeymankar] = useState({id:"",title:""});
  const [dataOrigin, setDataOrigin] = useState({id:"",title:""});
  const [dataDestination, setDataDestination] = useState({id:"",title:""});
  const [dataShift, setDataShift] = useState({id:"",title:""});
  const [selectedFieldIndex, setSelectedFieldIndex] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [openModalDriver, setOpenModalDriver] = useState(false);
  const [openModalEquipment, setOpenModalEquipment] = useState(false);
  const [openModalOperator, setOpenModalOperator] = useState(false);
  const [openModalProject, setOpenModalProject] = useState(false);
  const [openModalLocation, setOpenModalLocation] = useState(false);
  const [openModalPeymankar, setOpenModalPeymankar] = useState(false);
  const [openModalOrigin, setOpenModalOrigin] = useState(false);
  const [openModalDestination, setOpenModalDestination] = useState(false);
  const [openModalShift, setOpenModalShift] = useState(false);
  const [openModalJens, setOpenModalJens] = useState(false);
  const [openModalJensCode, setOpenModalJensCode] = useState(false);
  const [openModalWeight, setOpenModalWeight] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCargoById(id);

        if (response.status === 'success') {
          const cargo = response.data;

          setFormData({
            rent: cargo.amount,
            totalCost: cargo.sum_amount,
            operation: cargo.type_full.toString(),
            description: cargo.desc,
          });


          setData({
            id: cargo.machine_id,
            title: cargo.machine?.name || '',
            drivers: cargo.machine?.drivers || []
          });

          setDataDriver({
            id: cargo.driver_id,
            title: cargo.driver?.name || ''
          });

          setDataEquipment({
            id: cargo.equipment_id,
            title: cargo.equipment?.name || '',
            operators: cargo.equipment?.operators || []
          });

          setDataOperator({
            id: cargo.operator_id,
            title: cargo.operator?.name || ''
          });

          setDataProject({
            id: cargo.project_id,
            title: cargo.project?.title || ''
          });

          setDataLocations({
            id: cargo.location_id,
            title: cargo.location?.name || ''
          });

          setDataPeymankar({
            id: cargo.peymankar_id,
            title: cargo.peymankar?.name || ''
          });

          setDataOrigin({
            id: cargo.origin_id,
            title: cargo.origin?.title || ''
          });

          setDataDestination({
            id: cargo.destination_id,
            title: cargo.destination?.title || ''
          });

          setDataShift({
            id: cargo.shift_id,
            title: cargo.shift?.name || ''
          });

          if (cargo.jensItems?.length > 0) {
            setFields(cargo.jens.map(item => ({
              id: item.id,
              jens: { id: item.jens_id, title: item.jens?.title || '' },
              itemNumber: item.jens_number || '',
              code: { id: item.jens_code_id, title: item.jens_code?.title || '' },
              quantity: item.jens_unit || '',
              weight: { id: item.weight_id, title: item.weight?.title || '' },
              unit: item.weight_unit || '',
            })));
          }
        } else {
          toast.error(response.message);
          navigate(-1);
        }
      } catch (error) {
        toast.error('خطا در دریافت اطلاعات');
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleAddField = () => {
    setFields([...fields, {
      jens: {id:"",title:""},
      itemNumber: "",
      code: {id:"",title:""},
      quantity: "",
      weight: {id:"",title:""},
      unit: ""
    }]);
  };

  const handleRemoveField = (index) => {
    setFields(fields.filter((_, i) => i !== index));
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = [...fields];
    updatedFields[index][field] = value;
    setFields(updatedFields);
  };

  const handleSelectJens = (index, selectedJens) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, jens: selectedJens } : field
    );
    setFields(updatedFields);
  };

  const openJensModal = (index) => {
    setSelectedFieldIndex(index);
    setOpenModalJens(true);
  };

  const onJensSelected = (selectedJens) => {
    if (selectedFieldIndex !== null) {
      handleSelectJens(selectedFieldIndex, selectedJens);
      setOpenModalJens(false);
    }
  };

  const handleSelectJensCode = (index, selectedJens) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, code: selectedJens } : field
    );
    setFields(updatedFields);
  };

  const openJensCodeModal = (index) => {
    setSelectedFieldIndex(index);
    setOpenModalJensCode(true);
  };

  const onJensCodeSelected = (selectedJens) => {
    if (selectedFieldIndex !== null) {
      handleSelectJensCode(selectedFieldIndex, selectedJens);
      setOpenModalJensCode(false);
    }
  };

  const handleSelectWeight = (index, selectedWeight) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, weight: selectedWeight } : field
    );
    setFields(updatedFields);
  };

  const openWeightModal = (index) => {
    setSelectedFieldIndex(index);
    setOpenModalWeight(true);
  };

  const onWeightSelected = (selectedWeight) => {
    if (selectedFieldIndex !== null) {
      handleSelectWeight(selectedFieldIndex, selectedWeight);
      setOpenModalWeight(false);
    }
  };

  const handleSubmit = async () => {
    setPending(true);
    const requestData = {
      id: id,
      rent: formData.rent,
      totalCost: formData.totalCost,
      type: formData.operation,
      desc: formData.description,
      date: selectedDate ? moment(selectedDate).format("YYYY-MM-DD HH:mm:ss") : null,
      machine_id: data?.id || null,
      driver_id: dataDriver?.id || null,
      equipment_id: dataEquipment?.id || null,
      operator_id: dataOperator?.id || null,
      project_id: dataProject?.id || null,
      location_id: dataLocations?.id || null,
      peymankar_id: dataPeymankar?.id || null,
      origin_id: dataOrigin?.id || null,
      destination_id: dataDestination?.id || null,
      shift_id: dataShift?.id || null,
      jensItems: fields.map(item => ({
        id: item.id,
        jens_id: item.jens?.id,
        jens_code_id: item.code?.id,
        jens_unit: item.quantity,
        jens_number: item.itemNumber,
        weight_id: item.weight?.id,
        weight_unit: item.unit
      }))
    };

    try {
      const res = await updateCargo(requestData);

      if (res.status === "success") {
        toast.success('بارگیری با موفقیت ویرایش شد!');
        navigate(-1);
      } else {
        toast.error(res.message || 'خطا در ویرایش بارگیری');
      }
    } catch (error) {
      toast.error('خطا در ارسال اطلاعات');
    } finally {
      setPending(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex flex-col justify-center items-center h-screen">
          <CircularProgress color={"info"}/>
          <p className={"mt-5"}>درحال دریافت داده ها...</p>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <>
      <ModalSelectMachine
        showModal={openModal}
        setShowModal={setOpenModal}
        onSelectedIdsChange={(data) => setData(data)}
      />

      <ModalDriverSingleWithData
        data={data.drivers}
        showModal={openModalDriver}
        setShowModal={setOpenModalDriver}
        onSelectedIdsChange={(data) => setDataDriver(data)}
      />

      <ModalSelectEquipment
        showModal={openModalEquipment}
        setShowModal={setOpenModalEquipment}
        onSelectedIdsChange={(data) => setDataEquipment(data)}
      />

      <ModalOperatorSingleWithData
        data={dataEquipment.operators}
        showModal={openModalOperator}
        setShowModal={setOpenModalOperator}
        onSelectedIdsChange={(data) => setDataOperator(data)}
      />

      <ModalSelectProject
        showModal={openModalProject}
        setShowModal={setOpenModalProject}
        onSelectedIdsChange={(data) => setDataProject(data)}
      />

      <ModalSelectLocation
        showModal={openModalLocation}
        setShowModal={setOpenModalLocation}
        onSelectedIdsChange={(data) => setDataLocations(data)}
      />

      <ModalSelectPeymankar
        showModal={openModalPeymankar}
        setShowModal={setOpenModalPeymankar}
        onSelectedIdsChange={(data) => setDataPeymankar(data)}
      />

      <ModalSelectOrigin
        showModal={openModalOrigin}
        setShowModal={setOpenModalOrigin}
        onSelectedIdsChange={(data) => setDataOrigin(data)}
      />

      <ModalSelectDestination
        showModal={openModalDestination}
        setShowModal={setOpenModalDestination}
        onSelectedIdsChange={(data) => setDataDestination(data)}
      />

      <ModalSelectShift
        showModal={openModalShift}
        setShowModal={setOpenModalShift}
        onSelectedIdsChange={(data) => setDataShift(data)}
      />

      <ModalSelectJens
        showModal={openModalJens}
        setShowModal={setOpenModalJens}
        onSelectedIdsChange={onJensSelected}
      />

      <ModalSelectJensCode
        showModal={openModalJensCode}
        setShowModal={setOpenModalJensCode}
        onSelectedIdsChange={onJensCodeSelected}
      />

      <ModalSelectWeight
        showModal={openModalWeight}
        setShowModal={setOpenModalWeight}
        onSelectedIdsChange={onWeightSelected}
      />

      <DashboardLayout>
        <div className="w-full h-full">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="md:col-span-2">
              <div className="grid grid-cols-1 p-6 bg-white sm:grid-cols-2 gap-4 w-full">
                <input
                  readOnly
                  onClick={() => setOpenModal(true)}
                  value={data.title}
                  type="text"
                  placeholder="انتخاب دستگاه"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalShift(true)}
                  value={dataShift.title}
                  type="text"
                  placeholder="شیفت"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalDriver(true)}
                  value={dataDriver.title}
                  type="text"
                  placeholder="راننده"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalEquipment(true)}
                  value={dataEquipment.title}
                  type="text"
                  placeholder="تجهیز بارگیری"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalOperator(true)}
                  value={dataOperator.title}
                  type="text"
                  placeholder="اپراتور"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalProject(true)}
                  value={dataProject.title}
                  type="text"
                  placeholder="انتخاب پروژه"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalLocation(true)}
                  value={dataLocations.title}
                  type="text"
                  placeholder="محل استقرار"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <DatePicker
                  placeholder={"تاریخ"}
                  selected={selectedDate}
                  onChange={handleDateChange}
                  className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <input
                  readOnly
                  onClick={() => setOpenModalPeymankar(true)}
                  value={dataPeymankar.title}
                  type="text"
                  placeholder="پیمانکار"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  type="number"
                  name="rent"
                  placeholder="کرایه"
                  value={formData.rent}
                  onChange={handleChange}
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  name="totalCost"
                  placeholder="هزینه کل عملیات"
                  value={formData.totalCost}
                  onChange={handleChange}
                  type="number"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <select
                  name="operation"
                  value={formData.operation}
                  onChange={handleChange}
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="1">بارگیری</option>
                  <option value="2">تخلیه بار</option>
                </select>

                <input
                  readOnly
                  onClick={() => setOpenModalOrigin(true)}
                  value={dataOrigin.title}
                  type="text"
                  placeholder="مبدا"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <input
                  readOnly
                  onClick={() => setOpenModalDestination(true)}
                  value={dataDestination.title}
                  type="text"
                  placeholder="مقصد"
                  className="p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <textarea
                  name="description"
                  placeholder="توضیحات"
                  className="p-2 rounded bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 col-span-1 md:col-span-2"
                  rows="3"
                  value={formData.description}
                  onChange={handleChange}
                />

                <div className="flex gap-4 mt-4 col-span-1 md:col-span-2">
                  <MDButton
                    color="info"
                    onClick={handleSubmit}
                    disabled={pending}
                  >
                    {pending ? <CircularProgress size={24} color="inherit" /> : 'ذخیره تغییرات'}
                  </MDButton>
                  <MDButton
                    color="error"
                    onClick={() => navigate(-1)}
                  >
                    انصراف
                  </MDButton>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg shadow">
              <h2 className="text-xl font-bold mb-4">کالا</h2>

              <MDButton
                color="success"
                onClick={handleAddField}
                className="w-full mb-4"
              >
                افزودن کالا
              </MDButton>

              <div className="space-y-4 mt-5 max-h-[calc(100vh-200px)] overflow-y-auto">
                {fields.map((field, index) => (
                  <div key={index} className="bg-white p-4 rounded shadow relative">
                    <button
                      onClick={() => handleRemoveField(index)}
                      className="absolute top-2 left-2 text-red-500 hover:text-red-700"
                    >
                      <DeleteIcon fontSize="small" />
                    </button>

                    <div className="grid grid-cols-2 gap-3 mt-6">
                      <div className="col-span-2">
                        <label className="block text-sm font-medium mb-1">کالا</label>
                        <input
                          readOnly
                          onClick={() => openJensModal(index)}
                          value={field.jens.title}
                          type="text"
                          placeholder="انتخاب کالا"
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">شماره کالا</label>
                        <input
                          type="text"
                          placeholder="شماره کالا"
                          value={field.itemNumber}
                          onChange={(e) => handleFieldChange(index, "itemNumber", e.target.value)}
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">کد کالا</label>
                        <input
                          readOnly
                          onClick={() => openJensCodeModal(index)}
                          type="text"
                          placeholder="کد کالا"
                          value={field.code.title}
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      {/* تعداد */}
                      <div>
                        <label className="block text-sm font-medium mb-1">تعداد</label>
                        <input
                          type="number"
                          placeholder="تعداد"
                          value={field.quantity}
                          onChange={(e) => handleFieldChange(index, "quantity", e.target.value)}
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      {/* وزن */}
                      <div>
                        <label className="block text-sm font-medium mb-1">وزن</label>
                        <input
                          type="text"
                          placeholder="وزن"
                          value={field.unit}
                          onChange={(e) => handleFieldChange(index, "unit", e.target.value)}
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>

                      {/* واحد */}
                      <div>
                        <label className="block text-sm font-medium mb-1">واحد</label>
                        <input
                          type="text"
                          placeholder="واحد"
                          value={field.weight.title}
                          readOnly
                          onClick={() => openWeightModal(index)}
                          className="w-full p-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}